import { toObjectMap } from "@@/utilities/dictionary";

const shippingSlotStatus = ["ACTIVE", "FULL", "INACTIVE"] as const;
type shippingSlotStatus = (typeof shippingSlotStatus)[number];
const shippingSlotStatusMap = toObjectMap<shippingSlotStatus>([
    ...shippingSlotStatus,
]);

export { shippingSlotStatusMap, shippingSlotStatus };
